export const getAssessmentYear = () => {
  const NOW = new Date().getFullYear();
  const checkMonth = new Date().getMonth() + 1;

  if (checkMonth >= 7) {
    return NOW + " - " + (NOW + 1);
  } else {
    return NOW - 1 + " - " + NOW;
  }
};

export const assessmentYearNow = getAssessmentYear();
